import React from 'react';
import AdminYoutubeChannelsApi from '../../components/admin/AdminYoutubeChannelsApi';

const AdminYoutubeChannelsApiPage = () => {
  return <AdminYoutubeChannelsApi />;
};

export default AdminYoutubeChannelsApiPage;
